import React from "react";
import pallete from "../../assets/icons/pallete.svg";
import pill from "../../assets/icons/pill.svg";
import hug from "../../assets/icons/hug.svg";
import FeatureCard from "./FeatureCard/FeatureCard";
import "./MoreFeatures.css";
import { TranslationsMap } from "../../pages/CountryPage/CountryPage";

interface MoreFeaturesProps {
  translations: TranslationsMap;
}

const MoreFeatures: React.FC<MoreFeaturesProps> = ({ translations }) => {
  return (
    <div className="more-features-container">
      <h1 className="more-features-header">
        {translations["landingPage.moreFeatures.title"]}
      </h1>
      <div className="feature-cards-container">
        <FeatureCard
          iconSrc={pill}
          label={translations["landingPage.moreFeatures.feel.title"]}
          body={translations["landingPage.moreFeatures.feel.body"]}
        />
        <FeatureCard
          iconSrc={hug}
          label={translations["landingPage.moreFeatures.discover.title"]}
          body={translations["landingPage.moreFeatures.discover.body"]}
        />
        <FeatureCard
          iconSrc={pallete}
          label={translations["landingPage.moreFeatures.tools.title"]}
          body={translations["landingPage.moreFeatures.tools.body"]}
        />
      </div>
    </div>
  );
};

export default MoreFeatures;
